var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('public-title',[_vm._v("\n      会场资料\n    "),(_vm.storeId)?_c('span',{staticClass:"text-link ml-auto h6",attrs:{"slot":"right"},on:{"click":function($event){return _vm.$router.back()}},slot:"right"},[_vm._v("返回上一页")]):_vm._e()]),_c('div',{staticClass:"load-area"},[_c('room-meet-lists',{staticClass:"p-4 bg-white w-d"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }